export const BAND_WIDTH_SIZE = ['Kbps', 'Mbps', 'Gbps'];

export function formatBytes(bytes, toUnit, decimals = 2) {
  if (!+bytes) return { value: 0, unit: 'Kbps' };

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const indexSize = BAND_WIDTH_SIZE.indexOf(toUnit);
  if (indexSize === -1) {
    return { value: bytes, unit: 'Kbps' };
  }

  return {
    value: parseFloat((bytes / Math.pow(k, indexSize)).toFixed(dm)),
    unit: BAND_WIDTH_SIZE[indexSize],
  };
}
